/**
 * CharacterConfig
 * 
 * Default stats, position, and gold for new characters.
 */

export const CHARACTER_CONFIG = {
  defaultPosition: { x: 200, y: 300 },
  defaultHealth: 120,
  defaultMaxHealth: 120,
  defaultGold: 100,
  defaultStats: {
    projection: 10,
    resonance: 10,
    fortitude: 10,
    creation: 10,
    control: 10,
    insight: 10,
    anomaly: 10
  }
} as const;
